import React, { useState, useEffect, useRef, useMemo, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { MenuDiv } from "./Menu";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import Tabs from "../components/Tabs";
import { getStorage, clearStorage } from "../utils/storage.js";
import { isDebug } from "../config/env.js";

function Home() {
  const navigate = useNavigate();
  const location = useLocation();
  const refTabs = useRef();
  const [selectedProgramName, setSelectedProgramName] = useState("");
  const [regOption, setRegOption] = useState(() => String(getStorage("regOption", "2"))); // storage에서 초기값 읽기 (문자열로 변환)

  // storage에서 regOption 읽기 (로그인 후 업데이트 감지)
  useEffect(() => {
    const storedRegOption = String(getStorage("regOption", "2")); // 문자열로 명시적 변환
    if (storedRegOption !== regOption) {
      setRegOption(storedRegOption);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // 컴포넌트 마운트 시 한 번만 실행

  const program = useMemo(() => {
    const data = getStorage("program", location.state?.program);
    
    // data가 배열이 아니거나 비어있으면 빈 배열 반환
    if (!Array.isArray(data) || data.length === 0) {
      console.warn("No program data found in storage or state", { data, state: location.state });
      return [];
    }
    
    // regOption에 따라 메뉴 필터링
    // regOption === '1' (자사용): jcrm001-007만 표시
    // regOption === '2' (업체용): ocrm001-007만 표시
    const regOptionStr = String(regOption); // 문자열로 명시적 변환 (JSON.parse로 숫자가 될 수 있음)
    
    if (process.env.NODE_ENV === "development") {
      console.log("Home - program data:", data);
      console.log("Home - regOption (raw):", regOption, "type:", typeof regOption);
      console.log("Home - regOption (str):", regOptionStr, "type:", typeof regOptionStr);
      console.log("Home - location.state:", location.state);
    }
    const filteredData = data.filter((it) => {
      const programId = it.PROGRAM_ID; // 대문자 키만 사용
      if (!programId) return false;
      if (regOptionStr === '1') {
        return programId.startsWith('jcrm');
      } else {
        return programId.startsWith('ocrm');
      }
    });
    
    if (process.env.NODE_ENV === "development") {
      console.log("Home - filtered program count:", filteredData.length);
      console.log("Home - filtered programs:", filteredData.map(it => it.PROGRAM_ID));
    }
    
    return filteredData.map((it) => ({
      ...it,
      PROGRAM_ID: it.PROGRAM_ID, // 대문자 키만 사용
      PROGRAM_NAME: it.PROGRAM_NAME || it.PROGRAM_ID, // 대문자 키만 사용
      IMAGE_URL: `${isDebug() ? "" : "."}/images/${it.PROGRAM_ID.slice(-2)}.png`,
      SELECTED_IMAGE_URL: `${isDebug() ? "" : "."}/images/${it.PROGRAM_ID.slice(-2)}-s.png`,
    }));
  }, [location.state, regOption]); // location.state와 regOption을 의존성 배열에 추가

  const logOut = useCallback(() => {
    clearStorage();
    navigate("/", { replace: true });
  }, [navigate]);

  useEffect(() => {
    if (!getStorage("user_id")) {
      navigate("/", { replace: true });
    }
  }, [navigate]);

  useEffect(() => {
    if (refTabs.current) {
      setSelectedProgramName(refTabs.current.getTitleAt(0));
    }
  }, []);

  const handleTabSelected = useCallback((e) => {
    if (refTabs.current) {
      setSelectedProgramName(refTabs.current.getTitleAt(e.args.item));
    }
  }, []);

  return (
    <>
      <div
        style={{
          width: "100%",
          height: "100%",
          overflow: "hidden",
        }}
      >
        <Tabs
          ref={refTabs}
          onSelected={handleTabSelected}
          onLogOut={logOut}
        >
          <ul style={{ marginLeft: 4, backgroundColor: "rgb(12,126,177)" }}>
            {program.map((program) => (
              <li
                key={program.PROGRAM_ID}
                data-imageurl={program.IMAGE_URL}
                data-selectedimageurl={program.SELECTED_IMAGE_URL}
              >
                {program.PROGRAM_NAME}
              </li>
            ))}
          </ul>
          {program.map((program) => (
            <MenuDiv
              key={program.PROGRAM_ID}
              id={program.PROGRAM_ID}
              name={program.PROGRAM_NAME}
              selected={selectedProgramName}
            />
          ))}
        </Tabs>
      </div>
    </>
  );
}

export default Home;
